import React from "react";
import _ from "lodash";

import { NetworkAPI, UnitAPI } from "apis";
import NetworkPageWrapper from "components/diagnoser/NetworkPageWrapper";
import YieldSetsMultiSelector from "components/ops-mgmt/account/YieldSetsMultiSelector";

import LoadingUI from "components/common/LoadingUI";

import OptionSelector from "./OptionSelector";
import AllSelectBtn from "./AllSelectBtn";
import UnitsSelectionTable from "./UnitsSelectionTable";

import { YIELD_SET, UNIT_MODE, UNIT_STATUS, SPECIAL_UNIT_TYPE } from "./Utils";

class UnitsSearchViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errMsg: null,
      expErrMsg: null,

      networkId: null,
      networkInfo: null,
      selectedYieldSet: null,

      filter: {
        ys: YIELD_SET.ALL,
        mode: UNIT_MODE.ALL,
        status: UNIT_STATUS.ALL,
        specialUnit: SPECIAL_UNIT_TYPE.ALL,
      },

      ysData: null,

      units: null,
      tags: null,
    };

    this.unitsTableRef = React.createRef();

    this._getQueryParams = this._getQueryParams.bind(this);
    this.searchUnits = this.searchUnits.bind(this);
    this.handleYsChanged = this.handleYsChanged.bind(this);
    this.handleModeChanged = this.handleModeChanged.bind(this);
    this.handleStatusChanged = this.handleStatusChanged.bind(this);
    this.handleLoadYsData = this.handleLoadYsData.bind(this);
  }

  async componentDidMount() {
    const networkId = _.get(this.props, "match.params.networkId");
    this.setState({ networkId, isLoading: true });

    if (networkId) {
      try {
        const networkInfo = await NetworkAPI.getNetworkInfo({ networkId });
        this.setState({ networkInfo, errMsg: null });
      } catch (err) {
        this.setState({
          errMsg: err,
          networkInfo: null,
        });
      }
      this.setState({ isLoading: false });
    }
  }

  handleLoadYsData(items) {
    this.setState({ ysData: items });
  }

  handleModeChanged(newMode) {
    let filter = { ...this.state.filter };
    filter.mode = newMode;

    this.setState({ filter });
  }

  handleStatusChanged(newStatus) {
    let filter = { ...this.state.filter };
    filter.status = newStatus;

    this.setState({ filter });
  }

  handleYsChanged(ys) {
    const newYs = ys.length === 0 ? YIELD_SET.ALL : ys;
    let filter = { ...this.state.filter };
    filter.ys = newYs;

    this.setState({
      filter,
      selectedYieldSet: newYs === YIELD_SET.ALL ? null : newYs,
    });
  }

  _getQueryParams() {
    const { filter } = this.state;

    let queryParams = {};
    if (filter.ys !== YIELD_SET.ALL) {
      // queryParams.yieldSetId = filter.ys.yieldSetId;
      queryParams.yieldSetIds = filter.ys.map((ys) => ys.yieldSetId);
    }

    if (filter.mode !== UNIT_MODE.ALL) {
      queryParams.mode = filter.mode;
    }

    if (filter.status !== UNIT_STATUS.ALL) {
      queryParams.status = filter.status;
    }

    return queryParams;
  }

  async searchUnits() {
    this.setState({ isLoading: true });
    try {
      const networkId = this.state.networkId;
      const queryParams = this._getQueryParams();
      // new api
      const r = await UnitAPI.searchUnits({ networkId, ...queryParams });
      const { tags } = await UnitAPI.getAllUnitTags();

      const countByTags = tags.map((tag) => ({
        tag,
        count: _.filter(
          r.units,
          (u) => _.findIndex(u.tags, (uTag) => _.includes(uTag, tag)) > -1
        ).length,
      }));

      this.setState(
        {
          units: r.units,
          tags: _.orderBy(countByTags, ["count"], ["desc"]),
        },
        () => {
          this.unitsTableRef.current.handleClearAll();
        }
      );
    } catch (err) {
      console.log(err);
      this.setState({
        errMsg: err,
      });
    }
    this.setState({ isLoading: false });
  }

  render() {
    const {
      isLoading,
      errMsg,
      networkId,
      networkInfo,

      filter,
      selectedYieldSet,
      isFilterDisabled = false,
      units,
      tags,

      ysData,
    } = this.state;

    const unitModeOptions = _.transform(
      UNIT_MODE,
      (result, value) => {
        result[value] = { text: value };
      },
      {}
    );

    const unitStatusOptions = _.transform(
      UNIT_STATUS,
      (result, value) => {
        result[value] = { text: value };
      },
      {}
    );

    const filteredYs = _.filter(ysData, (ys) => {
      return (
        filter.ys === YIELD_SET.ALL ||
        _.findIndex(filter.ys, (f) => f.yieldSetId === ys.yieldSetId) > -1
      );
    });

    return (
      <>
        <BaseHeader title="Units Search"></BaseHeader>
        <NetworkPageWrapper
          // isLoading={isLoading}
          errMsg={errMsg}
          networkInfo={networkInfo}
        >
          <div className="border rounded mb-2 bg-white p-4">
            <div className="mb-2 flex items-center gap-2 text-sm font-semibold">
              <div className="w-20">YieldSet: </div>
              <AllSelectBtn
                value={filter.ys}
                handleClick={() => this.handleYsChanged(YIELD_SET.ALL)}
              ></AllSelectBtn>
              <div className="w-1/2">
                {networkId && (
                  <YieldSetsMultiSelector
                    networkId={networkId}
                    handleOnChange={this.handleYsChanged}
                    handleOnLoadData={this.handleLoadYsData}
                    selectedYieldSet={selectedYieldSet}
                    defaultValue={filter.ys}
                  ></YieldSetsMultiSelector>
                )}
              </div>
            </div>
            <div className="mb-2 flex items-center gap-2 text-sm font-semibold">
              <div className="w-20">Unit Mode: </div>
              <OptionSelector
                selected={filter.mode}
                options={unitModeOptions}
                allKey={UNIT_MODE.ALL}
                handleSelectChanged={this.handleModeChanged}
              ></OptionSelector>
            </div>

            <div className="mb-2 flex items-center gap-2 text-sm font-semibold">
              <div className="w-20">Unit Status: </div>
              <OptionSelector
                selected={filter.status}
                options={unitStatusOptions}
                allKey={UNIT_STATUS.ALL}
                handleSelectChanged={this.handleStatusChanged}
              ></OptionSelector>
            </div>

            <button
              type="button"
              onClick={this.searchUnits}
              className={`rounded px-6 py-2 font-semibold text-white ${
                isFilterDisabled
                  ? "bg-blue-200"
                  : "shadow bg-blue-400 hover:bg-blue-500"
              }`}
              disabled={isFilterDisabled}
            >
              Get units
            </button>
          </div>

          {errMsg && <div className="text-red-600">{errMsg}</div>}
          {isLoading && (
            <div className="fixed left-0 top-0 flex h-screen w-screen items-center justify-center">
              <div>
                <LoadingUI></LoadingUI>
              </div>
            </div>
          )}

          {units && (
            <UnitsSelectionTable
              ref={this.unitsTableRef}
              networkId={networkId}
              ysData={filteredYs}
              units={units}
              tags={tags}
            ></UnitsSelectionTable>
          )}
        </NetworkPageWrapper>
      </>
    );
  }
}

const BaseHeader = ({ title }) => {
  return (
    <div className="border-b bg-gray-100 px-12 py-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="text-lg font-semibold text-gray-800">{title}</div>
        </div>
      </div>
    </div>
  );
};

export default UnitsSearchViewer;
